import type { SVGProps } from "react"
import { forwardRef } from "react"

export const EllipsisIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
	(props, ref) => (
		<svg
			ref={ref}
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			{...props}
		>
			<circle cx="12" cy="12" r="1" />
			<circle cx="19" cy="12" r="1" />
			<circle cx="5" cy="12" r="1" />
		</svg>
	),
)

export const EllipsisVerticalIcon = forwardRef<
	SVGSVGElement,
	SVGProps<SVGSVGElement>
>((props, ref) => (
	<svg
		ref={ref}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		{...props}
	>
		<circle cx="12" cy="12" r="1" />
		<circle cx="12" cy="5" r="1" />
		<circle cx="12" cy="19" r="1" />
	</svg>
))
